import { NodeResult, ValueItem } from '@/services/api.types';
import { ResultModel } from '@/utils/measurements/node-results/result.interface';
import _ from 'lodash';

export abstract class NodeResultAbstract implements ResultModel {
  protected unit: string;
  protected jsonValue: object;
  protected node: NodeResult;

  constructor(node: NodeResult) {
    this.jsonValue = node.measurement_result?.value
      ? JSON.parse(node.measurement_result.value)
      : [];
    this.unit = node.measurement_result?.unit ?? '';
    this.node = node;
  }

  abstract getValue(key?: string): number | string | undefined;
  abstract getValues(): number[] | string[];
  abstract getMeasurementValues<T>(): Array<T & ValueItem>;
  abstract toString(): string;

  getUnit(): string {
    return this.unit;
  }

  getMeasurementType(): string {
    return this.node.measurement_type?.name ?? '';
  }

  getCompletedAt(): Date {
    return new Date(this.node.completion_time * 1000);
  }

  getNode(): NodeResult {
    return this.node;
  }

  protected getFirstValueChild<T>(): T & ValueItem {
    const values = this.getAllValueChildren<T>();
    return values?.[0];
  }

  protected getAllValueChildren<T>(): Array<T & ValueItem> {
    let values = this.jsonValue as Array<T & ValueItem>;
    if (values) {
      values = _.orderBy(values, ['completed_time'], ['desc']);
    }
    return values;
  }
}
